import { ProFormColumnsType } from '@ant-design/pro-form/es/components/SchemaForm/typing';

export const makeFormReadonly = (items: any): ProFormColumnsType[] =>
  items.map((item: any) => ({
    ...item,
    formItemProps: {
      ...item.formItemProps,
      className: 'pointer-events-none',
    },
    fieldProps:
      typeof item.fieldProps === 'function'
        ? (...args: any) => ({
            ...item.fieldProps(...args),
            variant: 'filled',
          })
        : {
            ...item.fieldProps,
            variant: 'filled',
          },
    columns: Array.isArray(item.columns)
      ? makeFormReadonly(item.columns) // Recursively process each column
      : typeof item.columns === 'function'
      ? (...args: any) => makeFormReadonly(item.columns(...args)) // Wrap function to apply recursively
      : item.columns,
  }));
